import {documentReady, debouncer, toggleClassOnScroll} from '../Utility/utils';


const InitializeNav = () => {
  documentReady(event => {

    // Menu Toggle
    const nav = document.querySelector('.main-navigation');
    const header_el = document.querySelector('#masthead');
    const menu_toggle = header_el.querySelector('.menu-toggle');

    function toggleMenu(e){
      // Set Active Class
      nav.classList.toggle('toggled');
      header_el.classList.toggle('toggled');
      menu_toggle.classList.toggle('active');

      // Set Aria Hidden Attribute
      const aria_status = nav.classList.contains('toggled') ? 'true' : 'false';
      menu_toggle.setAttribute('aria-expanded', aria_status);
    }

    menu_toggle.addEventListener('click', toggleMenu);
    header_el.querySelectorAll('a').forEach((el)=> {
      el.addEventListener('click', (e) => {
        const is_desktop = menu_toggle.offsetParent === null;
        if (!is_desktop && menu_toggle.classList.contains('active')) {
          toggleMenu(e);
        }
      })
    });

    // Set menu state on load and resize if changing from mobile to desktop.
    function set_menu_state(){
      // Since we don't know the menu breakpoint, check if the menu toggle is visible
      const is_desktop = menu_toggle.offsetParent === null ? true : false;

      // Desktop
      if(is_desktop){
        // if mobile state classes are present, remove them.
        if(nav.classList.contains('toggled')){
          nav.classList.remove('toggled');
          header_el.classList.remove('toggled');
          menu_toggle.classList.remove('active');
        }

        // set aria-hidden if not already set to false
        if(menu_toggle.getAttribute('aria-expanded') !== 'true'){
          menu_toggle.setAttribute('aria-expanded', 'true');
        }
      }
      // Mobile
      else {
        // set aria-hidden if not already set to true and if menu isn't currently active
        if(!nav.classList.contains('toggled') && menu_toggle.getAttribute('aria-expanded') !== 'false'){
          menu_toggle.setAttribute('aria-expanded', 'false');
        }
      }
    }
    set_menu_state();

    // Resize modals on window resize
    window.addEventListener('resize', debouncer(function(){
      set_menu_state();
    }, 15));



    toggleClassOnScroll('#masthead', 'scrolled', 'top', 'window-scrolled');
  });
}

export { InitializeNav };
